import store from "@/store";
import { setCookie, getCookie, removeCookie } from '@/utils/yl-cookie'
import { defaultSettings } from '@/settings'
const tokenKey = defaultSettings.token.key

export function getToken() {
  return getCookie(tokenKey)
}

export function setToken(token) {
  return setCookie(tokenKey, token)
}

export function removeToken() {
  return removeCookie(tokenKey)
}

export function getUserInfo() {
  return store.getters["user/userInfo"];
}

  
